// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__thg8c","link":"menu_link__gFBfJ","active":"menu_active__zKux3"};